import { render } from "./ClaimListItem.vue?vue&type=template&id=2152a01c&scoped=true&bindings={}"
import script from "./ClaimListItem.vue?vue&type=script&lang=ts"
export * from "./ClaimListItem.vue?vue&type=script&lang=ts"

import "./ClaimListItem.vue?vue&type=style&index=0&id=2152a01c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2152a01c"

export default script